// mutations
const SET_RESSHULIST = (state, payload) => {
  state.res_list_shu = payload;
};
const SET_STARTYEAR = (state, payload) => {
  state.start_year = payload;
};
const SET_ENDYEAR = (state, payload) => {
  state.end_year = payload;
};
const SET_RESCHARTSHU = (state, payload) => {
  state.res_chartshu = payload;
};
const SET_RESFILESHU = (state, payload) => {
  state.res_fileshu = payload
}
export default {
  SET_RESSHULIST,
  SET_STARTYEAR,
  SET_ENDYEAR,
  SET_RESCHARTSHU,
  SET_RESFILESHU
};
